import { render, staticRenderFns } from "./About_C.vue?vue&type=template&id=f5ed1c64&scoped=true"
import script from "./About_C.vue?vue&type=script&lang=js"
export * from "./About_C.vue?vue&type=script&lang=js"
import style0 from "./About_C.vue?vue&type=style&index=0&id=f5ed1c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed1c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VImg,VLayout,VRow})
